import { useAuth } from '@payflip/web/auth';
import { downloadBlob } from '../utils/download-blob';
import { useGetBlobLazyQuery } from './queries.generated';

export function useDownloadBlob(): (blobId: string) => Promise<void> {
  const { getAccessToken } = useAuth();
  const [getBlobLazyQuery] = useGetBlobLazyQuery({
    fetchPolicy: 'cache-and-network'
  });

  const download = async (blobId: string): Promise<void> => {
    const token = (await getAccessToken()) ?? '';
    const { data } = await getBlobLazyQuery({
      variables: { id: blobId }
    });

    if (!data) {
      return;
    }

    downloadBlob(blobId, data.blob.name, token);
  };

  return download;
}
